export const Constant = {
  PROJECT_NAME: "gearbox",
  PROJECT_TAG_LINE: "Indian automobile spare parts industry",
  PRICE: "₹"
};

export const DEFAULT_PRIMARY_COLOR = "#055392";
export const DEFAULT_SECONDARY_COLOR = "#94C13E";

export const INDIA_COUNTRY = "6782b75edfa7a09bfa27b0eb";

export const MAKE_URL = (path, data) => `${path}${data?._id ? `/${data._id}` : ""}`;

export const FILE_TYPES = ["image/png", "image/jpg", "image/jpeg", "image/avif", "image/webp", "image/svg", "image/gif"]
export const IMAGE_TYPES = ["image/png", "image/jpg", "image/jpeg", "image/avif", "image/webp", "image/svg", "image/gif"]

export const LANGUAGE_COLORS = {
  'English': 'blue',
  'Hindi': 'orange',
  'Gujarati': 'green',
  'default': 'default'
};

export const getSortOrder = (sortBy, field) => {
  if (!sortBy) return null;

  const [sortField, sortDirection] = sortBy.split(":");
  if (sortField !== field) return null;

  return sortDirection === "asc" ? "ascend" : "descend";
};
